<template lang="pug">
el-form-item(:label="label")
  el-select(:value="value", v-on="$listeners", filterable, clearable)
    el-option(v-for="{ groupName, groupId } in modelList", :key="groupId", :label="groupName", :value="groupId")
</template>
<script>
export default {
  inheritAttrs: false,
  inject: ["metaSideNode"],
  props: {
    value: { default: undefined, type: [String, Array] },
    label: { default: "关联模型", type: String }
  },
  computed: {
    modelList() {
      let node = this.metaSideNode();
      while (node.level > 2) node = node.parent;
      const list = node.childNodes.find((e) => e.label === "业务模型").childNodes.map(({ data }) => data) || [];
      return list;
    }
  }
};
</script>
